import React, { ChangeEvent, FunctionComponent, useCallback } from 'react'

import { TextInput } from '../atoms'
import { sanitisePartialPostalCode } from '../extensions'
import { FreeTextInputProps } from './FreeTextInput'

export const PostcodeInput: FunctionComponent<FreeTextInputProps> = ({
  onChange,
  value,
  ...props
}) => {
  const onInputChange = useCallback(
    ({ target }: ChangeEvent<HTMLInputElement>) =>
      onChange(sanitisePartialPostalCode(target.value)),
    [onChange],
  )

  return <TextInput variant='ghost' value={value} onChange={onInputChange} {...props} />
}
